import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLoadingPanelComponent } from './app-loading-panel.component';
import { AppLoadingService } from '../app-loading-panel/app-loading.service';

@NgModule({
  imports: [CommonModule],
  declarations: [AppLoadingPanelComponent],
  exports: [AppLoadingPanelComponent],
  providers: [AppLoadingService]
})
export class AppLoadingPanelModule { }
